module.exports = __webpack_public_path__ + "img/0.6.png";